import React, { useEffect, useState } from "react";
import { View, Text, StyleSheet } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { Color, globalStyle } from "../assets";
import FastImage from "../common/FastImage";
import {logoName, no_internet} from "../utils/images";
import {globalConfigurableData, globalConst} from "../utils/globalConstant";

const NoInternetScreen = () => {
  const styles = StyleSheet.create({
    img: {
      width: "100%",
      height: "50%",
      alignContent: "center",
      justifyContent: "center",
    },
  });

  return (
    <SafeAreaView
      style={{
        flex: 1,
        paddingHorizontal: 16,
        flexDirection: "column",
      }}
    >
        <FastImage
            style={{
                height: 30,
                width: 80,
            }}
            source={globalConfigurableData?.logoUrl()}
        />
      <FastImage
        style={styles.img}
        source={no_internet()}
      />
      <Text
        style={[
          globalStyle.headerBlue,
          { paddingTop: 16, textAlign: "center" },
        ]}
      >
        Whoops!
      </Text>
      <Text style={[{ paddingTop: 16, textAlign: "center" }]}>
        No internet connection found.
      </Text>
      <Text style={[{ textAlign: "center" }]}>
        Please check your internet settings.
      </Text>
    </SafeAreaView>
  );
};

export default NoInternetScreen;
